export class CreateRestoreTemplateResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreTemplate",
            "baseName": "restoreTemplate",
            "type": "RestoreTemplate",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateRestoreTemplateResponse.attributeTypeMap;
    }
    constructor() {
    }
}
